import './PageLayout.scss'

const PageLayout = (props) => {
  return (
    <>
      <h2 className="container mb-sm">{props.title}</h2>
      {props.children}
    </>
  )
}

export default PageLayout;